import { createFileRoute } from '@tanstack/react-router';
import {
    useCommonStore,
    useCreatedSearchStore,
    useLoginStore,
    usePersistStore,
    useSearchStore,
} from '@/shared/lib/store';
import { useEffect } from 'react';
import { CreatedBoxComponent } from '../sets/created-box';
import { PublishedBoxComponent } from '../sets/published-box';

export const Route = createFileRoute('/my-bank/')({
    component: MyBankPage,
    pendingComponent: MyBankPending,
    pendingMs: 0,
    pendingMinMs: 0,
});

function MyBankPending() {
    return (
        <div
            aria-busy="true"
            style={{ backgroundColor: '#fff', minHeight: '100vh', padding: '48px 24px' }}
        >
            <p role="status" style={{ textAlign: 'center', color: '#667085' }}>
                내 문제은행을 불러오는 중입니다.
            </p>
        </div>
    );
}

function MyBankPage() {
    const { myBankTab, setMyBankTab, setInKeyword } = useSearchStore();
    const { prevPath } = useCommonStore();
    const { setKeyword } = useCreatedSearchStore();
    const { loginInfo } = useLoginStore();
    const { sVivaToken, setSMyClassMemberList } = usePersistStore();

    useEffect(() => {
        if (!sVivaToken || !loginInfo.memberId) return;

        const refreshClassMemberList = () => {
            void setSMyClassMemberList({ teacherId: loginInfo.memberId, validYn: 'N' }, sVivaToken);
        };

        refreshClassMemberList();

        window.addEventListener('focus', refreshClassMemberList);
        return () => window.removeEventListener('focus', refreshClassMemberList);
    }, [loginInfo.memberId, sVivaToken, setSMyClassMemberList]);

    useEffect(() => {
        if (!!prevPath && !prevPath.includes('sets/published-box/detail')) {
            setMyBankTab('created');
        }
    }, []);

    useEffect(() => {
        setKeyword('');
        setInKeyword('');
    }, [myBankTab]);

    return (
        <div style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
            {myBankTab === 'created' ? <CreatedBoxComponent /> : <PublishedBoxComponent />}
        </div>
    );
}
